import Vue from 'vue'
import VueRouter from 'vue-router'
import Stores from '@/components/stores/Stores'
import EditStore from '@/components/stores/EditStore'
import Countries from '@/components/countries/Countries'
import EditCountry from '@/components/countries/EditCountry'
import Regions from '@/components/regions/Regions'
import EditRegion from '@/components/regions/EditRegion'
import Tenders from '@/components/tenders/Tenders'
import EditTender from '@/components/tenders/EditTender'
import NewTender from '@/components/tenders/NewTender'
import MerchandiseHierarchies from '@/components/merchandiseHierarchies/MerchandiseHierarchies'
import EditMerchandiseHierarchy from '@/components/merchandiseHierarchies/EditMerchandiseHierarchy'
import NewMerchandiseHierarchy from '@/components/merchandiseHierarchies/NewMerchandiseHierarchy'
import Currencies from '@/components/currencies/Currencies'
import EditCurrency from '@/components/currencies/EditCurrency'
import Taxes from '@/components/taxes/Taxes'
import EditTax from '@/components/taxes/EditTax'
import ECommerces from '@/components/eCommerces/ECommerces'
import EditECommerce from '@/components/eCommerces/EditECommerce'
import StoresOverwritten from '@/components/overwritten/stores/Stores'
import RegionsOverwritten from '@/components/overwritten/regions/Regions'
import CountriesOverwritten from '@/components/overwritten/countries/Countries'
import ECommercesOverwritten from '@/components/overwritten/eCommerces/ECommerces'
import CurrenciesOverwritten from '@/components/overwritten/currencies/Currencies'
import TaxesOverwritten from '@/components/overwritten/taxes/Taxes'
import Home from "../components/Home";
import {isTokenValid} from "../requesters/httpClient";
import {parameters} from "../parameters";
import Fed from "../views/Fed";

Vue.use(VueRouter)

const router =  new VueRouter({
  name: "ReferentialRouter",
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/stores',
      name: 'Stores',
      component: Stores,
      meta: {
        title: 'Business Units > Stores'
      }
    },
    {
      path: '/editStore',
      name: 'EditStore',
      component: EditStore,
      meta: {
        title: 'Business Units > Store > Edit'
      }
    },
    {
      path: '/storesOverwritten',
      name: 'StoresOverwritten',
      component: StoresOverwritten
      ,
      meta: {
        title: 'Overwritten > Stores'
      }
    },
    {
      path: '/countries',
      name: 'Countries',
      component: Countries,
      meta: {
        title: 'Business Units > Countries'
      }
    },
    {
      path: '/editCountry',
      name: 'EditCountry',
      component: EditCountry,
      meta: {
        title: 'Business Units > Country > Edit'
      }
    },
    {
      path: '/countriesOverwritten',
      name: 'CountriesOverwritten',
      component: CountriesOverwritten,
      meta: {
        title: 'Overwritten > Countries'
      }
    },
    {
      path: '/regions',
      name: 'Regions',
      component: Regions,
      meta: {
        title: 'Business Units > Regions'
      }
    },
    {
      path: '/editRegion',
      name: 'EditRegion',
      component: EditRegion,
      meta: {
        title: 'Business Units > Region > Edit'
      }
    },
    {
      path: '/regionsOverwritten',
      name: 'RegionsOverwritten',
      component: RegionsOverwritten,
      meta: {
        title: 'Overwritten > Regions'
      }
    },
    {
      path: '/tenders',
      name: 'Tenders',
      component: Tenders,
      meta: {
        title: 'Others > Tenders'
      }
    },
    {
      path: '/editTender',
      name: 'EditTender',
      component: EditTender,
      meta: {
        title: 'Others > Tender > Edit'
      }
    },
    {
      path: '/newTender',
      name: 'NewTender',
      component: NewTender,
      meta: {
        title: 'Others > Tender > New'
      }
    },
    {
      path: '/merchandise-hierarchies',
      name: 'MerchandiseHierarchies',
      component: MerchandiseHierarchies,
      meta: {
        title: 'Others > MerchandiseHierarchies'
      }
    },
    {
      path: '/editMerchandiseHierarchy',
      name: 'EditMerchandiseHierarchy',
      component: EditMerchandiseHierarchy,
      meta: {
        title: 'Others > MerchandiseHierarchy > Edit'
      }
    },
    {
      path: '/newMerchandiseHierarchy',
      name: 'NewMerchandiseHierarchy',
      component: NewMerchandiseHierarchy,
      meta: {
        title: 'Others > MerchandiseHierarchy > New'
      }
    },
    {
      path: '/currencies',
      name: 'Currencies',
      component: Currencies,
      meta: {
        title: 'Others > Currencies'
      }
    },
    {
      path: '/editCurrency',
      name: 'EditCurrency',
      component: EditCurrency,
      meta: {
        title: 'Others > Currency > Edit'
      }
    },
    {
      path: '/currenciesOverwritten',
      name: 'CurrenciesOverwritten',
      component: CurrenciesOverwritten,
      meta: {
        title: 'Overwritten > Currencies'
      }
    },
    {
      path: '/taxes',
      name: 'Taxes',
      component: Taxes,
      meta: {
        title: 'Taxes'
      }
    },
    {
      path: '/editTax',
      name: 'EditTax',
      component: EditTax,
      meta: {
        title: 'Taxe > Edit'
      }
    },
    {
      path: '/taxesOverwritten',
      name: 'TaxesOverwritten',
      component: TaxesOverwritten,
      meta: {
        title: 'Overwritten > Taxes'
      }
    },
    {
      path: '/ecommerces',
      name: 'ECommerces',
      component: ECommerces,
      meta: {
        title: 'Business Units > Ecommerces'
      }
    },
    {
      path: '/editECommerce',
      name: 'EditECommerce',
      component: EditECommerce,
      meta: {
        title: 'Business Units > Ecommerce > Edit'
      }
    },
    {
      path: '/ecommercesOverwritten',
      name: 'ECommercesOverwritten',
      component: ECommercesOverwritten,
      meta: {
        title: 'Overwritten > Ecommerces'
      }
    },
    {
      name: 'fed',
      path: '/accessToken/:fedParams?',
      component: Fed
    },
    {
      name: '*',
      path: 'HomeDefault',
      component: Home
    },
  ]
})

// Add guard for every route to validate authentication (or redirect to Fed)
router.beforeEach(async (to, from, next) => {
  if(to.name ==='fed') {
    next();
  } else if(!isTokenValid()) {
    sessionStorage.setItem('poslog_url_backup', window.location.href);
    const codeVerifier = makeRandomString(50)
    const hashedCodeChallenge = await encryptS256CodeChallenge(codeVerifier)
    sessionStorage.setItem('hashedCodeChallenge', hashedCodeChallenge)
    sessionStorage.setItem('codeVerifier', codeVerifier)
    location.replace(`${parameters.fedUrl}/as/authorization.oauth2?client_id=${parameters.clientId}&response_type=code&redirect_uri=${parameters.redirectUri}&scope=openid%20profile%20email&code_challenge=`+ hashedCodeChallenge + `&code_challenge_method=S256`);
  } else {
    next();
  }
});

function makeRandomString(length) {
  let result           = '';
  let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  const crypto = window.crypto || window.msCrypto;
  let array = new Uint32Array(1);
  for ( let i = 0; i < length; i++ ) {
    crypto.getRandomValues(array);
    result += characters.charAt(array[0] % charactersLength);
  }
  return result;
}

function hash256String(str) {
  const crypto = window.crypto || window.msCrypto;
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  return crypto.subtle.digest("SHA-256", data);
}

function base64urlencode(a) {
  let str = "";
  let bytes = new Uint8Array(a);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

async function encryptS256CodeChallenge(str) {
  return base64urlencode(await hash256String(str))
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js